import { motion } from "framer-motion";
import { fadeUp, easeExpo } from "@/lib/motion";

const PARTNERS = [
  "NVIDIA",
  "Intel",
  "AMD",
  "Samsung",
  "Micron",
  "Kingston",
  "Western Digital",
  "SK Hynix",
  "Crucial",
  "Cisco",
  "Arrow Electronics",
];

export default function PartnerMarquee() {
  const loop = [...PARTNERS, ...PARTNERS];

  return (
    <section
      id="partners"
      className="relative py-28 md:py-36 border-t border-white/5"
      data-testid="section-partners"
    >
      <div className="mx-auto max-w-[1440px] px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-end mb-14">
          <div className="lg:col-span-1 text-[11px] font-mono tracking-[0.22em] uppercase text-electric-500">
            05
          </div>
          <div className="lg:col-span-11">
            <div className="text-[11px] font-mono tracking-[0.22em] uppercase text-slate-400 mb-4">
              / Trusted Channels
            </div>
            <motion.h2
              {...fadeUp}
              className="font-display font-extrabold text-3xl md:text-5xl lg:text-6xl tracking-[-0.03em] leading-[1] text-white max-w-[1000px]"
            >
              Authorized sources.
              <br />
              <span className="text-slate-400">
                No gray market. No compromises.
              </span>
            </motion.h2>
          </div>
        </div>

        <div className="relative marquee-fade overflow-hidden">
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1.2, ease: easeExpo }}
            className="flex gap-14 md:gap-20 animate-marquee-x-slow whitespace-nowrap py-6"
            style={{ width: "max-content" }}
          >
            {loop.map((p, i) => (
              <div
                key={`${p}-${i}`}
                className="flex items-center gap-4"
                data-testid={`partner-${p.toLowerCase().replace(/\s+/g, "-")}`}
              >
                <span className="w-1.5 h-1.5 rounded-full bg-electric-500/60" />
                <span className="font-display text-3xl md:text-5xl lg:text-6xl font-light text-slate-100 tracking-tight leading-none">
                  {p}
                </span>
              </div>
            ))}
          </motion.div>
        </div>

        {/* Second slower editorial marquee */}
        <div className="relative marquee-fade overflow-hidden mt-6 border-t border-white/5 pt-6">
          <div
            className="flex gap-10 animate-marquee-x whitespace-nowrap py-2"
            style={{ width: "max-content", animationDirection: "reverse" }}
          >
            {loop.map((p, i) => (
              <span
                key={`sub-${p}-${i}`}
                className="text-[11px] md:text-xs font-mono tracking-[0.22em] uppercase text-slate-500"
              >
                Authorized · {p}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
